<template lang="pug">
  .panel-page
    FormErrorAlert.error(v-if="message"
                          @dismiss="message = ''"
                          :message="message")
    .panel.mx-auto.body-1
      h1 Set Password for Account
      ChangePasswordWidget(
        :message.sync="message"
        @password="changePassword($event)"
        :current-password-needed="false"
        :username="username"
        :firstName="firstName"
        :lastName="lastName"
        save-button-text="Submit"
      )
</template>

<script>
import FormErrorAlert from '@/components/FormErrorAlert'
import ChangePasswordWidget from '@/components/ChangePasswordWidget'
import axios from '@/lib/axios'
import { globalError, globalSuccess } from '@/lib/utils'

export default {
  name: 'CompleteSignup',
  data() {
    return {
      message: '',
      password: '',
      username: this.$route.params.username,
      firstName: this.$route.params.resp.data.firstName,
      lastName: this.$route.params.resp.data.lastName,
    }
  },
  methods: {
    changePassword({ newPassword }) {
      let { oldPassword, username } = this.$route.params
      if (oldPassword === newPassword) {
        this.message = 'New password must be different than the old password.'
        return
      }
      axios({ auth: false })
        .post('/api/change_password', {
          oldPassword: oldPassword,
          password: newPassword,
          username: username,
        })
        .then(() => {
          globalSuccess(null, 'The password was successfully reset.')
          this.$router.push({ name: 'login' })
        })
        .catch(err => globalError(err))
    },
  },
  components: {
    ChangePasswordWidget,
    FormErrorAlert,
  },
}
</script>

<style lang="scss" scoped>
.error {
  width: 835px;
  margin: auto;
  margin-bottom: 2rem;
}
</style>
